/**
 * Created by slava on 6/9/18
 */

const Tabs = cleverapps.Layout.extend({
    ctor: function (tabsInfo, options) {
        this.buttons = {};

        this.tabsOptions = options;

        this.changeIconColor = options.changeIconColor !== undefined ? options.changeIconColor : true;
        this.changeIconOpacity = options.changeIconOpacity !== undefined ? options.changeIconOpacity : true;
        this.changeTextOpacity = options.changeTextOpacity !== undefined ? options.changeTextOpacity : true;

        this.enabledTabFont = options.enabledTabFont || cleverapps.styles.FONTS.TABS_TEXT_FONT;
        this.disabledTabFont = options.disabledTabFont || cleverapps.styles.FONTS.TABS_TEXT_FONT_DISABLED;

        const styles = cleverapps.styles.Tabs;
        this.direction = options.direction === undefined ? styles.direction : options.direction;
        this.images = options.type || this.direction === cleverapps.UI.VERTICAL && Tabs.Types.tabs_vertical || Tabs.Types.tabs_horizontal;

        this.onTabChanged = function () {};

        const ids = Object.keys(tabsInfo).map(Number);
        this.firstTabId = Math.min(...ids);
        this.lastTabId = Math.max(...ids);

        const buttons = Object.keys(tabsInfo).map(function (id, index) {
            return this.createButton(id, tabsInfo[id], -(index + 1), options);
        }, this);

        const margin = Array.isArray(options.margin) ? options.margin[cleverapps.resolution.mode].margin : options.margin;

        this._super(buttons, {
            direction: this.direction,
            margin: margin === undefined ? styles.margin : margin
        });

        this.setCascadeOpacityEnabled(true);
    },

    getTabFrame: function (tabState, id) {
        let frameName;

        if (+id === this.firstTabId) {
            frameName = `${tabState}_png_first`;
        } else if (+id === this.lastTabId) {
            frameName = `${tabState}_png_last`;
        }
     
        if (!this.images[frameName]) {
            frameName = `${tabState}_png`;
        }

        return this.images[frameName];
    },

    createButton: function (id, info, order, options) {
        const styles = cleverapps.styles.Tabs.buttons;
        const size = (options.size || [])[cleverapps.resolution.mode] || options.size || {};
        const padding = (options.padding || [])[cleverapps.resolution.mode] || options.padding || {};
        const width = size.width || options.width || styles.width;
        const height = size.height || options.height || styles.height;
        const margin = options.margin || styles.margin || 0;
        const rect = cc.rectSubPadding(cc.rect(0, 0, width, height), cc.padding(styles.padding, padding));
        const maxScale = (options.iconMaxScale || [])[cleverapps.resolution.mode] || options.iconMaxScale || 1;

        const button = this.buttons[id] = cleverapps.UI.createScale9Sprite(this.getTabFrame(Tabs.TAB_STATE.OFF, id));
        button.info = info;
        button.baseScale = 1;
        button.baseZOrder = order;
        button.setLocalZOrder(button.baseZOrder);
        button.setContentSize(width, height);

        button.setCascadeOpacityEnabled(true);

        let icon;
        if (info.icon) {
            icon = button.icon = new cc.Sprite(info.icon);
        }
        if (info.node) {
            icon = info.node;
        }

        let text;
        if (info.text) {
            text = button.text = cleverapps.UI.generateOnlyText(info.text, this.enabledTabFont);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);
        }

        let content;
        if (icon) {
            if (text) {
                text.setDimensions(rect.width - icon.width - margin, 0);
                text.fitTo(undefined, rect.height);
                text.setDimensions(text.width, rect.height);
                content = new cleverapps.Layout([icon, text], {
                    direction: cleverapps.UI.HORIZONTAL,
                    margin 
                });
            } else {
                content = icon;
            }
            cleverapps.UI.fitToBox(content, { ...rect, maxScale });
        } else if (text) {
            content = text;
            text.fitTo(rect.width, rect.height);
        }

        if (text) {
            text.baseFontSzie = text.getFontSize();
        }

        content.setAlignment(rect.x + rect.width / 2, rect.y + rect.height / 2);
        button.addChild(content);

        if (!info.disabled) {
            button.clickHandler = cleverapps.UI.onClick(button, () => {
                if (this.selectedId !== id) {
                    cleverapps.effects.fire("ui.button.click");

                    this.activateTab(id);
                    return;
                }

                if (info.content.onClickTab) {
                    info.content.onClickTab();
                }
            }, {
                interactiveScale: this.tabsOptions.interactiveScale
            });
            button.hoverHandler = cleverapps.UI.applyHover(button, {
                interactiveScale: this.tabsOptions.interactiveScale
            });
        }

        button.setRecCascadeColorEnabled(true);
        button.setCascadeOpacityEnabledRecursively(true);

        if (info.disabled) {
            cleverapps.UI.convertToGrayScale(button);
        }

        if (info.tooltip) {
            cleverapps.tooltipManager.create(button, info.tooltip);
        }

        if (info.attention) {
            this.setAttention(id, info.attention);
        }

        const buttonSlot = button.buttonSlot = cleverapps.UI.wrapWithPadding(button);

        return buttonSlot;
    },

    getActive: function () {
        return this.selectedId;
    },

    activeTab: function () {
        return this.buttons[this.selectedId].info.content;
    },

    activateTab: function (selectedId, params) {
        let button;

        selectedId = selectedId.toString();

        if (this.selectedId === selectedId) {
            button = this.buttons[this.selectedId];
            return button && button.info && button.info.content;
        }

        Object.keys(this.buttons).forEach(function (id) {
            if (id === selectedId) {
                this.onSelectTab(id, params);
            } else {
                this.onUnSelectTab(id);
            }
        }, this);

        this.onTabChanged(this.selectedId);

        button = this.buttons[this.selectedId];
        return button && button.info && button.info.content;
    },

    onSelectTab: function (id, params) {
        const button = this.buttons[id];
        const info = button.info;

        button.hoverHandler.setEnabled(false);
        button.clickHandler.setEnabled(false);

        button.setSpriteFrame(this.getTabFrame(Tabs.TAB_STATE.ON, id));

        button.setLocalZOrder(1);

        if (info.updateTitle) {
            info.updateTitle();
        }

        if (button.text) {
            button.text.setFont(this.enabledTabFont);
            button.text.setFontSize(button.text.baseFontSzie);
            button.text.setOpacity(255);
        }

        if (button.icon) {
            if (this.changeIconColor) {
                button.icon.setColor(this.enabledTabFont.color);
            }
            button.icon.setOpacity(255);
        }

        if (info.content === undefined) {
            info.content = info.generator ? info.generator() : new cc.Node();
        }

        info.content.setVisible(true);

        if (info.content.onSelectTab) {
            info.content.onSelectTab(params);
        }

        this.selectedId = id;

        if (this.tabsOptions.moveUpSelected) {
            this.moveUp(button);
        }

        if (this.tabsOptions.selectedDh !== undefined) {
            button.setContentSize(button.width, button.height + this.tabsOptions.selectedDh);
        }

        if (this.tabsOptions.selectedDy !== undefined) {
            button.y += this.tabsOptions.selectedDy;
        }

        if (this.tabsOptions.selectAnimation) {
            const selectAnimation = TABS_ANIMATIONS[this.tabsOptions.selectAnimation];
            selectAnimation.call(button);
        }
    },

    onUnSelectTab: function (id) {
        const button = this.buttons[id];
        const info = button.info;

        button.hoverHandler.setEnabled(true);
        button.clickHandler.setEnabled(true);

        button.setSpriteFrame(this.getTabFrame(Tabs.TAB_STATE.OFF, id));

        button.setLocalZOrder(button.baseZOrder);

        if (button.text) {
            button.text.setFont(this.disabledTabFont);
            button.text.setFontSize(button.text.baseFontSzie);
            if (this.changeTextOpacity) {
                button.text.setOpacity(cleverapps.styles.Tabs.buttons.disabled.opacity);
            }
        }

        if (button.icon) {
            if (this.changeIconColor) {
                button.icon.setColor(this.disabledTabFont.color);
                button.icon.setOpacity(cleverapps.styles.Tabs.buttons.disabled.opacity);
            } else if (this.changeIconOpacity) {
                button.icon.setOpacity(cleverapps.styles.Tabs.buttons.disabled.colorIconOpacity);
            }
        }

        if (info.content === undefined) {
            return;
        }

        info.content.setVisible(false);
        info.content.stopAllActions();

        if (info.content.onUnSelectTab) {
            info.content.onUnSelectTab();
        }

        if (this.tabsOptions.moveUpSelected) {
            this.moveDown(button);
        }

        if (this.tabsOptions.selectedDh !== undefined) {
            button.setContentSize(button.width, button.height - this.tabsOptions.selectedDh);
        }

        if (this.tabsOptions.selectedDy !== undefined) {
            button.y -= this.tabsOptions.selectedDy;
        }
    },

    setAttention: function (id, attention) {
        const styles = this.tabsOptions.attention || cleverapps.styles.Tabs.attention;
        const button = this.buttons[id];

        if (button.attention) {
            button.attention.removeFromParent();
            delete button.attention;
        }

        if (attention) {
            button.attention = new Attention();
            button.attention.setAlignment(styles);

            button.addChild(button.attention);
        }
    },

    showUp: function () {
        const localZOrder = this.getLocalZOrder();

        this.setLocalZOrder(0);

        Object.values(this.buttons).forEach((button, index) => {
            const showPosition = button.getPosition();

            if (this.direction === cleverapps.UI.VERTICAL) {
                button.x += button.width;
            } else {
                button.y -= button.height;
            }

            button.runAction(new cc.Sequence(
                new cc.Hide(),
                new cc.DelayTime(0.13 + 0.05 * index),
                new cc.Show(),
                new cc.Spawn(
                    new cc.Sequence(
                        new cc.MoveBy(0.15, (showPosition.x - button.x) * 1.05, (showPosition.y - button.y) * 1.05),
                        new cc.MoveTo(0.1, showPosition)
                    ),
                    new cc.Sequence(
                        new cc.ScaleTo(0, 0.8, 1.2),
                        new cc.DelayTime(0.15),
                        new cc.ScaleTo(0.1, 1, 1)
                    )
                )
            ));
        });

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.13 + 0.05 * (Object.keys(this.buttons).length - 1) + 0.15),
            new cc.CallFunc(() => {
                this.setLocalZOrder(localZOrder);
            })
        ));
    },

    setMoveUpParent: function (moveUpParent) {
        this.moveUpParent = moveUpParent;
    },

    moveUp: function (tab) {
        if (this.moveUpParent) {
            tab.setScale(1);
            tab.replaceParentSamePlace(this.moveUpParent, { keepScale: true });
        }
    },

    moveDown: function (tab) {
        if (tab.parent !== tab.buttonSlot) {
            tab.replaceParentSamePlace(tab.buttonSlot);
        }
    },
    
    adjustTabs: function () {
        const selectedTab = this.buttons[this.selectedId];

        if (selectedTab && this.moveUpParent && selectedTab.parent === this.moveUpParent) {
            const slot = selectedTab.buttonSlot;

            const slotCenter = cc.p(slot.width / 2, slot.height / 2);
            selectedTab.setPosition(this.moveUpParent.convertToNodeSpace(slot.convertToWorldSpace(slotCenter)));
            
            const scale = cc.Base.AdjustScaleTo(slot, this.moveUpParent);
            selectedTab.setScaleX(scale.x);
            selectedTab.setScaleY(scale.y);
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TABS_TEXT_FONT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    TABS_TEXT_FONT_DISABLED: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

Tabs.TAB_STATE = {
    OFF: "off",
    ON: "on"
};

Tabs.Types = cleverapps.overrideTemplates({}, {
    tabs_vertical: {
        off_png: bundles.tabs.frames.vertical_tab_off,
        on_png: bundles.tabs.frames.vertical_tab_on
    },

    tabs_horizontal: {
        off_png: bundles.tabs.frames.tab_off,
        on_png: bundles.tabs.frames.tab_on
    },

    tabs_custom: {
        off_png: bundles.tabs.frames.custom_tab_off,
        on_png: bundles.tabs.frames.custom_tab_on
    },

    tabs_unit_shop: {
        off_png: bundles.tabs.frames.unit_shop_tab_off,
        on_png: bundles.tabs.frames.unit_shop_tab_on
    },

    tabs_bottom: {
        off_png: bundles.tabs.frames.bottom_tab_off,
        on_png: bundles.tabs.frames.bottom_tab_on
    },

    tabs_top: {
        off_png: bundles.tabs.frames.top_tab_off,
        on_png: bundles.tabs.frames.top_tab_on
    },

    tabs_shop: {
        off_png_first: bundles.tabs.frames.shop_tab_off_first,
        off_png_last: bundles.tabs.frames.shop_tab_off_last,

        on_png_first: bundles.tabs.frames.shop_tab_on_first,
        on_png_last: bundles.tabs.frames.shop_tab_on_last
    }
});

cleverapps.styles.Tabs = {
    margin: 0,
    direction: cleverapps.UI.HORIZONTAL,

    attention: {
        x: 0,
        y: 0
    },

    buttons: {
        width: 135,
        height: 240,
        margin: 5,
        padding: {
            x: 18,
            y: 12
        },

        disabled: {
            opacity: 127,
            colorIconOpacity: 127
        }
    }
};
